export default {
  menu: {
    SystemName: '系统名称',
    MenuNameCn: '菜单名称(中)',
    MenuNameEn: '菜单名称(英)',
    MenuCode: '菜单编号',
    Parent: '上级',
    ChooseParent: '选择上级',
    ParentName: '上级名称',
    Asp: 'ASP',
    SystemId: '系统Id',
    Default: '默认',
    Catalog: '目录',
    Link: '链接',
    IconsUrl: '上传图片',
    ComponentUrl: '组件路径',
    HiddenFlag: '隐藏标志',
    MatchPath: '匹配路径',
    ChooseSystem: '系统选择',
    PleaseChooseSystem: '请先选择系统'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/menu.js